<template>
    <el-form label-position="top" label-width="80px" style="margin:20px">
        <!-- 数据库 -->
        <el-form-item label="数据库配置" v-show="databases?.length">
            <el-table ref="elDatabasesTable" :data="databases" stripe>
                <el-table-column prop="caption" label="名称" width="250"></el-table-column>
                <el-table-column prop="value.host" label="服务器">
                    <template v-slot:default="props">
                        <el-input v-model="props.row.host"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="value.user" label="用户" width="120">
                    <template v-slot:default="props">
                        <el-input v-model="props.row.user"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="value.password" label="密码">
                    <template v-slot:default="props">
                        <el-input type="password" v-model="props.row.password"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="value.database" label="数据库">
                    <template v-slot:default="props">
                        <el-input v-model="props.row.database"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="value.port" label="端口" width="100">
                    <template v-slot:default="props">
                        <el-input v-model="props.row.port"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
        </el-form-item>

        <!-- 服务器 -->
        <el-form-item label="服务器配置" v-show="services?.length">
            <el-table ref="elServicesTable" :data="services" row-key="name" stripe>
                <el-table-column prop="caption" label="名称" width="250"></el-table-column>
                <el-table-column prop="value" label="地址">
                    <template v-slot:default="props">
                        <el-input v-model="props.row['value']"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
        </el-form-item>

        <!-- 系统参数 -->
        <el-form-item label="系统参数" v-show="params?.length">
            <el-table ref="elParamsTable" :data="params" stripe>
                <el-table-column prop="caption" label="名称" width="250"></el-table-column>
                <el-table-column prop="value" label="值">
                    <template v-slot:default="props">
                        <el-input v-model="props.row['value']"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
        </el-form-item>

        <el-button type="primary" @click="onSave">保存配置</el-button>
    </el-form>
</template>

<script>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'

import systemService from '../../services/system.service'
import httpService from '../../services/http.service'

export default {
    name: 'tw-tablet-options',
    setup() {
        // 系统参数
        const databases = ref([])
        const services = ref([])
        const params = ref([])

        const promiseDatabases = httpService.get('admin-config-databases', { project_id: systemService.project_id })
        const promiseServices = httpService.get('admin-config-services', { project_id: systemService.project_id })
        const promiseParams = httpService.get('admin-config-params', { project_id: systemService.project_id })
        Promise.all([promiseDatabases, promiseServices, promiseParams]).then(results => {
            databases.value = results[0]
            services.value = results[1]
            params.value = results[2]
        }).catch(err => {
            ElMessage.info({
                showClose: true,
                message: err.message
            })
        })

        const onSave = function() {
            const promiseDatabases = new Promise((resolve, reject) => {
                if (databases.value.length) {
                    httpService.put('admin-config-databases', { project_id: systemService.project_id }, databases.value).then(() => {
                        resolve()
                    }).catch(err => {
                        console.error(err)
                        reject({ message: `保存数据库配置时出错` })
                    })
                } else {
                    resolve()
                }
            })
            const promiseServices = new Promise((resolve, reject) => { 
                if (services.value.length) {
                    httpService.put('admin-config-services', { project_id: systemService.project_id }, services.value).then(() => {
                        resolve()
                    }).catch(err => {
                        console.error(err)
                        reject({ message: `保存服务器配置时出错` })
                    })
                } else {
                    resolve()
                }
            })
            const promiseParams = new Promise((resolve, reject) => {
                if (params.value.length) {
                    httpService.put('admin-config-params', { project_id: systemService.project_id }, params.value).then(() => {
                        resolve()
                    }).catch(err => {
                        console.error(err)
                        reject({ message: `保存系统参数时出错` })
                    })
                } else {
                    resolve()
                }
            })

            Promise.all([promiseDatabases, promiseServices, promiseParams]).then(() => {
                ElMessage.info({
                    showClose: true,
                    message: '保存成功'
                })
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message
                })
            })
        }

        return {
            databases,
            services,
            params,
            onSave
        }
    }
}
</script>

<style>

</style>